








































































































































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { BusyObject } from '@/models/Busy';
import { AgentExecutionFrequency } from '@/models/AgentExecutionFrequency';
import { Brand, BrandIndexItem, BrandQueryResultItem, Monitoring, MonitoringsService, User } from '@/api/braendz';
import { Locale, findLocale, locales } from '@/models/Locale';
import { createQueryByBrand } from '@/logic/Monitoring';

import Popup from '@/components/Popups/Popup.vue';
import ConfirmationPopup from '@/components/Popups/ConfirmationPopup.vue'

@Component({
    components: {
        Popup,
        ConfirmationPopup
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class CreateBrandMonitoringPopup extends Vue {
    // Member
    public visibility = false;

    public valid = true;
    public selectedTab = 0;
    public createdMonitoring = new BusyObject<Monitoring>();

    public name: string | null = null;
    public description: string | null = null;
    public executionFrequency: AgentExecutionFrequency | null = null;

    public mailingEnabled = false;
    public mailingTo: string | null = null;
    public mailingCc: string[] = [];
    public mailingCcListItems: string[] = [];
    public mailingCulture: Locale | null = null;
    public mailingOnlyOnChange = false;

    public resultSize = 10;
    public resultSizes = [ 10, 25, 50 ];

    public minNameSimilarityScore = 0.7;
    public minLogoSimilarityScore = 0.9;
    public searchOnlyNewBrands = false;

    public showCreatedConfirmation = false;

    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({required: true})
    public brand!: BrandQueryResultItem | BrandIndexItem | Brand;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }

    public get brandId(): string | null {
        if(!this.brand) {
            return null;
        }

        if("brandId" in this.brand && this.brand.brandId) {
            return this.brand.brandId;
        } 
        else if("id" in this.brand && this.brand.id) {
            return this.brand.id;
        }
        else if("indexItem" in this.brand && this.brand.indexItem?.brandId) {
            return this.brand.indexItem.brandId;
        }

        return null;
    }

    public get userMailAddress(): string | null | undefined {
        return (this.$store.state.user as BusyObject<User>)?.object?.mailAddress;
    }

    public get locales(): Locale[] {
      return locales;
    }

    // Watcher:

    // Lifecycle Methods:
    public mounted() {
        this.reset();
    }

    // Methods:
    public async create(): Promise<void> {
        if (!((this.$refs.form as Vue & { validate: () => boolean }).validate())) {
            return;
        }

        await this.createdMonitoring.create(async () => {
            const query = await createQueryByBrand(
                this.brand, 
                this.resultSize, 
                this.minNameSimilarityScore, 
                this.minLogoSimilarityScore, 
                undefined, // Specific registration office codes
                this.searchOnlyNewBrands, 
                undefined, // Excluded brand IDs
                undefined  // Ignored brand IDs
            );

            const monitoring = {
                name: this.name,
                description: this.description,
                brandId: this.brandId,
                settings: { query: query },
                executionFrequency: this.executionFrequency,
                mailingEnabled: this.mailingEnabled,
                mailingTo: this.mailingTo,
                mailingCc: this.mailingCc,
                mailingCulture: this.mailingCulture?.locale,
                mailingOnlyOnChange: this.mailingOnlyOnChange
            } as Monitoring;

            return await MonitoringsService.upsertMonitoringCurrentUserDefaultAccount(monitoring);
        });

        this.showCreatedConfirmation = true;
    }

    public removeCcItem(item: string) {
        const itemIndex = this.mailingCc.indexOf(item);
        if (itemIndex >= 0) this.mailingCc.splice(itemIndex, 1);
    }

    public validateMailAddresses(values: []): true | string {
        return values.length <= 0 
            ? true 
            : !values.find(m => this.$validation.mail(m, '') !== true);
    }

    public reset(): void {
        this.showCreatedConfirmation = false;
        this.name = null;
        this.description = null;
        this.executionFrequency = null;
        this.mailingEnabled = false;
        this.mailingOnlyOnChange = false;
        this.mailingTo = this.userMailAddress ?? null;
        this.mailingCc = [];
        this.mailingCulture = findLocale(this.$i18n.locale) ?? findLocale('en-GB') ?? locales[0];
        this.resultSize = 10;
        this.minNameSimilarityScore = 0.7;
        this.minLogoSimilarityScore = 0.9;
        this.searchOnlyNewBrands = false;
        this.selectedTab = 0;
    }

    public openCreatedMonitoring(): void {
        const createdId = this.createdMonitoring.object?.id;
        if(createdId) {
            this.$router.push( { name: 'Monitoring', params: { lang: this.$i18n.locale, id: createdId } });
        }
        this.close();
    }

    public close(): void {
        this.visible = false;
    }
}
